export default __webpack_public_path__ + "static/media/mod11.a92cfb05.png";